import '@vfde-brix/timeline-stepper/dist/styles.css';

import {createTimelineStepperComponent} from '@vfde-brix/timeline-stepper';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-timeline-stepper');

for (let i = 0, x = elements.length; i < x; i += 1) {

    createTimelineStepperComponent(elements[i], NO_PATTERN_BUSINESS_LOGIC);

}

console.log('foo');
